module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sarah-linder-f24023d996c45fe42bec31a89a295299.jpg";